import React, { useState } from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import Notes from "./Notes";

const dataToggle = [
    { href: "#notes", name: "NEW", value: false },
    { href: "#notes", name: "SEEN", value: true },
];

const Notifications = ({ onClick, toggle, seen, setSeen, tableParams, setTableParams, notificationsData, getNotifications }) => {

    const [toggleTab, settoggleTab] = useState("NEW");

    const onChangeTab = (name, value) => {
        settoggleTab(name);
        setSeen(value);
        setTableParams(prevState => ({
            ...prevState,
            current: 1,
        }));
    };

    return (
        <div className={`chatbox ${toggle === "notification" ? "active" : ""}`}>

            <div className="chatbox-close" onClick={() => onClick()}></div>

            <div className="custom-tab-1">

                <ul className="nav nav-tabs">
                    {dataToggle.map((data, i) => (
                        <li className="nav-item" key={i}>
                            <Link
                                className={`nav-link ${toggleTab === data.name ? "active active-notification-tab" : ""}`}
                                to="#"
                                data-toggle="tab"
                                href={data.href}
                                onClick={() => onChangeTab(data.name, data.value)}
                            >
                                {data.name}
                            </Link>
                        </li>
                    ))}
                </ul>

                <div className="tab-content">
                    <Notes
                        toggleTab={toggleTab}
                        PerfectScrollbar={PerfectScrollbar}
                        toggle={toggle}
                        seen={seen}
                        tableParams={tableParams}
                        setTableParams={setTableParams}
                        notificationsData={notificationsData}
                        getNotifications={getNotifications}
                    />
                </div>

            </div>

        </div>
    );
};

export default Notifications;